import { Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import type { UTM as UTMType } from 'typings'
import { Tag } from 'ui'
import { messages } from './messages'

type UTMProps = {
  utm: UTMType | undefined
}
export function UTM(props: UTMProps) {
  const { formatMessage, formatList } = useIntl()
  const { utm } = props

  const noUtmSet = !utm || Object.values(utm).every((entry) => !entry.length)

  if (noUtmSet) return null

  const processTooltip = () => {
    const utms = Object.entries(utm)
      .filter(([_, values]) => values.length)
      .map(([key, values]) =>
        formatMessage(messages.utm.tooltip[key], {
          list: formatList(values, { type: 'disjunction' }),
        })
      )

    return formatList(utms)
  }

  return (
    <Tooltip text={processTooltip()}>
      <Tag>
        <FormattedMessage {...messages.utm.title} />
      </Tag>
    </Tooltip>
  )
}
